export const formLoanProperties = () => {
  if (process.env.NODE_ENV === 'development') {
    return {
      properties: {
        amount: {
          type: 'integer',
          title: 'Amount required',
          default: 50000,
          minimum: 10000,
          maximum: 500000
        },
        termLength: {
          type: 'integer',
          title: 'Term Duration',
          default: 1,
          minimum: 1
        },
        termUnit: {
          type: 'string',
          title: 'Term Unit',
          default: 'month',
          enum: ['week', 'month'],
          enumNames: ['Weekly', 'Monthly']
        },
        drawdownDate: {
          type: 'string',
          format: 'date',
          default: '2018-07-09',
          title: 'Drawdown Date',
        },
        purpose: {
          type: 'string',
          title: 'Where would you use the loan for?',
          default: 'Hire Staff',
          enum: [
            'Hire Staff', 'Working Capital', 'Marketing Campaign', 'Expand Premises', 'GST Payment',
            'Payroll Tax Payment', 'Tax Payment', 'Purchase Equipment', 'Debt Consolidation',
            'Payment of Existing Arrears', 'Other'
          ]
        },
        frequency: {
          type: 'string',
          title: 'How often would you like to make repayment?',
          default: 'month',
          enum: ['week', 'month'],
          enumNames: ['Weekly', 'Monthly']
        },
        contactNumber: {
          type: 'string',
          default: '0444444444',
          title: 'Your best contact number',
        },
        contactEmail: {
          type: 'string',
          title: 'Email address',
        },
      }
    };
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/fixtures/formLoanProperties.js